import { createFileRoute } from "@tanstack/react-router";

import { EncryptionGate } from "~/components/encryption-gate";
import { CoachLaneStack } from "~/components/engagement/coach-lane-stack";
import { CoachingHearth } from "~/components/engagement/coaching-hearth";
import { CoachingHomeSkeleton } from "~/components/engagement/coaching-home-skeleton";
import { ClientEngagementEmptyState } from "~/components/engagement/engagement-empty-state";
import { Card, CardContent } from "~/components/ui/card";
import { useUserCoachingHome } from "~/lib/queries/coachingHomeQuery";

export const Route = createFileRoute("/_user/coaching/")({
  component: RouteComponent,
  staticData: { title: "My coaching team" },
});

function RouteComponent() {
  const { data, isLoading, error } = useUserCoachingHome();

  const engagements = data?.engagements ?? [];
  const isInitialLoading = isLoading && !data;
  const isEmpty = !isLoading && !error && engagements.length === 0;
  const soloEngagement = engagements.length === 1 ? engagements[0] : null;

  return (
    <>
      {isInitialLoading && <CoachingHomeSkeleton />}

      {error && (
        <Card className="py-12">
          <CardContent className="text-center">
            <p className="mb-2 text-red-500">Error loading coaching programs</p>
            <p className="text-text-secondary mx-auto max-w-xs text-sm">
              Something went wrong. Please try again.
            </p>
          </CardContent>
        </Card>
      )}

      {isEmpty && <ClientEngagementEmptyState />}

      {/* Single coach → the immersive Hearth (gated: it shows the decrypted goal + wins). */}
      {soloEngagement && (
        <EncryptionGate fallback={<CoachingHomeSkeleton />}>
          <div className="mx-auto max-w-3xl">
            <CoachingHearth
              engagementId={soloEngagement.engagementId}
              variant="home"
              prefetchedMainGoal={soloEngagement.mainGoal}
            />
          </div>
        </EncryptionGate>
      )}

      {/* Multiple coaches → the prioritized lane stack (no encrypted content → no gate). */}
      {engagements.length > 1 && <CoachLaneStack engagements={engagements} />}
    </>
  );
}
